import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IonSegmentCustomEvent,
  SegmentChangeEventDetail,
  SegmentValue,
} from '@ionic/core';
import { map } from 'rxjs/operators';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { POPUP_LABEL, ProfileBundle, TABS } from './location-profile.constants';

@Component({
  selector: 'app-location-profile-popup',
  templateUrl: './location-profile-popup.component.html',
  styleUrls: ['./location-profile-popup.component.scss'],
  standalone: false,
})
export class LocationProfilePopupComponent implements OnInit {
  currentTab: string | SegmentValue = '';
  nextTab: string | SegmentValue = '';
  isFormComplete = false;

  readonly availableTabs = TABS;
  readonly CONSTANTS = { ...POPUP_LABEL };
  readonly IMAGES = IMAGE_SRC;

  readonly destroy = inject(DestroyRef);

  formDirty = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProfileBundle,
    private readonly locationService: LocationService,
    private commonUtils: CommonUtils,
    public readonly dialogRef: MatDialogRef<LocationProfilePopupComponent>,
  ) {}

  ngOnInit(): void {
    this.currentTab = TABS.LOCATION;
    this.locationService.setProfileState$(this.data?.profile);
    this.locationService
      .getProfileState$()
      .pipe(
        takeUntilDestroyed(this.destroy),
        map((state) => {
          this.data.profile = state;
        }),
      )
      .subscribe();
  }

  onFormChange(state: boolean): void {
    if (this.formDirty !== state) {
      this.formDirty = state;
    }
  }

  onSubmitClicked($event: any): void {
    if ($event?.redirect) {
      this.currentTab = $event.tab;
      return;
    }

    if (!this.data.edit) {
      this.data = $event.data;
      this.currentTab = $event.tab;
    }
  }

  onTabSelected($event: IonSegmentCustomEvent<SegmentChangeEventDetail>): void {
    if (this.data.edit) {
      this.nextTab = $event?.detail?.value ? $event.detail.value : 'fail';
      if (!this.formDirty) {
        this.currentTab = this.nextTab;
      }
    }
  }

  close() {
    this.commonUtils.openExitModal(this.formDirty);
  }
}
